import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
export var useDismissOnNav = function (onNav, navFilter, enabled) {
    if (navFilter === void 0) { navFilter = function () { return true; }; }
    if (enabled === void 0) { enabled = true; }
    var location = useLocation();
    useEffect(function () {
        if (enabled && navFilter(location.pathname)) {
            onNav();
        }
    }, [location.pathname]);
};
export var useOnNavAway = useDismissOnNav;
